import { useEffect, useState } from "react";
import "@/i18n";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Import pages
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Facturas from "@/pages/Facturas";
import DocumentosSoporte from "@/pages/DocumentosSoporte";
import Proveedores from "@/pages/Proveedores";
import Reportes from "@/pages/Reportes";
import Metricas from "@/pages/Metricas";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

function App() {
  const [dataSeeded, setDataSeeded] = useState(false);

  useEffect(() => {
    // Seed data on first load
    const seedData = async () => {
      try {
        const response = await axios.post(`${API}/seed`);
        console.log("Data seeded:", response.data);
        setDataSeeded(true);
      } catch (e) {
        console.log("Seed might already exist or error:", e.message);
        setDataSeeded(true);
      }
    };
    
    seedData();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="facturas" element={<Facturas />} />
            <Route path="documentos-soporte" element={<DocumentosSoporte />} />
            <Route path="proveedores" element={<Proveedores />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="metricas" element={<Metricas />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
